import React from 'react';
import PropTypes from 'prop-types';
import {Badge, Card, CardBody, CardText} from "reactstrap5";
import {FormattedMessage} from "react-intl";
import RecommendationsOffcanvas from "../../../../general/react/Recommendation/RecommendationsOffcanvas";
import Lottie from "react-lottie";
import VikyAnimation from "../../../animation/viky_anim_dance_slow.json"
import classnames from "classnames";

class RecommendationsCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openOffcanvas: false,
            activeClass: true
        }

        window.setTimeout(() => {
            this.setState({activeClass: false})
        }, 5000);
    }

    render() {
        const {recommendationActivities, colourTheme} = this.props;

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: VikyAnimation,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        return (
            <>
                <Card onClick={() => (this.setState({openOffcanvas: true}))} className={classnames({'active': this.state.activeClass})}>
                    <Badge color={'danger'}
                           className={'position-absolute top-0 end-0 translate-middle badge rounded-pill'}>
                        {recommendationActivities.length}
                    </Badge>
                    <div className={"viky-face text-center"}>
                        <Lottie options={defaultOptions} />
                        <strong className={'text-17'}>
                            <FormattedMessage
                                defaultMessage='VIKY DOPORUČUJE'/>
                        </strong>
                    </div>
                    <CardBody>
                        <CardText>
                            <div className={'d-flex flex-row'}>
                                <div className={'text-15'}>
                                    {recommendationActivities.length}{' '}
                                    <FormattedMessage
                                        defaultMessage='cvičení vybraná přímo pro tebe'/>
                                </div>
                                <a href="javascript:;"
                                   className="d-flex align-items-center justify-content-center ms-2">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         fill="none"
                                         className="text-white bg-black rounded-circle p-2 me-2 hw-30px"
                                         viewBox="0 0 24 24"
                                         stroke="currentColor"
                                         stroke-width="2">
                                        <path stroke-linecap="round"
                                              stroke-linejoin="round"
                                              d="M9 5l7 7-7 7"/>
                                    </svg>
                                </a>
                            </div>
                        </CardText>
                    </CardBody>
                </Card>
                {this.state.openOffcanvas && <RecommendationsOffcanvas recommendationActivities={recommendationActivities} colourTheme={colourTheme} close={() => (this.setState({openOffcanvas: false}))} />}
            </>
        );
    }
}

RecommendationsCard.propTypes = {
    recommendationActivities: PropTypes.array.isRequired,
    colourTheme: PropTypes.string,
};

export default RecommendationsCard;